import { Button, Modal } from "@scuf/common";
import { filealreadyexistEvent } from "../../../../../../common/utility/dataManagementUtils";

export const FileExistPopup = (props: any) => {
  const { fexist, setFexist, inputEle } = props;

  return (
    <Modal
      className="modal-content-dataManagement-wrapper"
      open={fexist}
      onClose={() => setFexist(false)}
      closeOnDimmerClick={false}
      closeOnDocumentClick={false}
    >
      <span className="modal-text-dataManagement">
        Folder already exists. Choose a different name.
      </span>
      <Modal.Footer className="modal-footer-dataManagement">
        <Button
          type="secondary"
          size="small"
          content="Ok"
          onClick={() => filealreadyexistEvent(setFexist, inputEle)}
          className="save-secondary-dataManagement"
        />
      </Modal.Footer>
    </Modal>
  );
};
